import React from 'react';

export default class DashboardIcon extends React.Component {
  render() {
    return (
      <svg height="100%" viewBox="0 0 18 17">
        <g>
          <path
            className="fill-none"
            fill="none"
            d="M14.519,13H3.481C3.215,13,3,13.215,3,13.481v0.038C3,13.785,3.215,14,3.481,14h11.038
            C14.785,14,15,13.785,15,13.519v-0.038C15,13.215,14.785,13,14.519,13z"
          />
          <path
            className="fill-none"
            fill="none"
            d="M14.519,10H3.481C3.215,10,3,10.215,3,10.481v0.038C3,10.785,3.215,11,3.481,11h11.038
            C14.785,11,15,10.785,15,10.519v-0.038C15,10.215,14.785,10,14.519,10z"
          />
          <path
            className="fill-none"
            fill="none"
            d="M14.519,7H3.481C3.215,7,3,7.215,3,7.481v0.038C3,7.785,3.215,8,3.481,8h11.038C14.785,8,15,7.785,15,7.519
            V7.481C15,7.215,14.785,7,14.519,7z"
          />
          <path
            fill="#BD311F"
            d="M4.178,0H3.822C3.797,0,3.775,0.012,3.75,0.015C3.332,0.053,3,0.395,3,0.823V2v1.177
            C3,3.631,3.369,4,3.822,4h0.355C4.631,4,5,3.631,5,3.177V2V1.323v-0.5C5,0.369,4.631,0,4.178,0z"
          />
          <path
            fill="#BD311F"
            d="M9.178,0H8.822C8.797,0,8.775,0.012,8.75,0.015C8.332,0.053,8,0.395,8,0.823V2v1.177
            C8,3.631,8.369,4,8.822,4h0.355C9.631,4,10,3.631,10,3.177V2V1.323v-0.5C10,0.369,9.631,0,9.178,0z"
          />
          <path
            fill="#BD311F"
            d="M14.178,0h-0.355c-0.026,0-0.047,0.012-0.072,0.015C13.332,0.053,13,0.395,13,0.823V2v1.177
            C13,3.631,13.369,4,13.822,4h0.355C14.631,4,15,3.631,15,3.177V2V1.323v-0.5C15,0.369,14.631,0,14.178,0z"
          />
          <path
            fill="#BD311F"
            d="M16,2v1.177C16,4.182,15.183,5,14.178,5h-0.355c-0.033,0-0.064-0.008-0.097-0.01
            C12.766,4.939,12,4.149,12,3.177V2h-1v1.177C11,4.182,10.183,5,9.178,5H8.822C8.789,5,8.758,4.992,8.726,4.99
            C7.766,4.939,7,4.149,7,3.177V2H6v1.177C6,4.182,5.183,5,4.178,5H3.822C3.789,5,3.758,4.992,3.726,4.99
            C2.766,4.939,2,4.149,2,3.177V2H0v15h18V2H16z M15,13.519C15,13.785,14.785,14,14.519,14H3.481C3.215,14,3,13.785,3,13.519v-0.038
            C3,13.215,3.215,13,3.481,13h11.038C14.785,13,15,13.215,15,13.481V13.519z M15,10.519C15,10.785,14.785,11,14.519,11H3.481
            C3.215,11,3,10.785,3,10.519v-0.038C3,10.215,3.215,10,3.481,10h11.038C14.785,10,15,10.215,15,10.481V10.519z M15,7.519
            C15,7.785,14.785,8,14.519,8H3.481C3.215,8,3,7.785,3,7.519V7.481C3,7.215,3.215,7,3.481,7h11.038C14.785,7,15,7.215,15,7.481
            V7.519z"
          />
        </g>
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/icons/TransactionsIcon.js